import React from "react";
import IndustryMainFragment from "./industry/IndustryMainFragment.jsx";


export default function LaunchpadMainFragment() {
	  
	  return (
				 <>
						<IndustryMainFragment/>
				 </>
	  );
}
